export default "__VITE_ASSET__3fa164bb__"